import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { FinanceCalc } from "@perxis-auto/ui-kit/lib/components/FinanceCalc";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import { selectSlice } from "../../../../features/tradeIn/model/selectors/selectSlice.js";
import "../../../../features/tradeIn/model/slice.js";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import styles from "./TradeInCard.module.scss.js";
const TradeInCard = memo(function TradeInCard2({ priceLabel, onClick }) {
  const { t } = useTranslation(APP.name);
  const tradeIn = useAppSelector(selectSlice);
  const priceValue = Number((tradeIn == null ? void 0 : tradeIn.min) || (tradeIn == null ? void 0 : tradeIn.avg) || (tradeIn == null ? void 0 : tradeIn.max) || 0);
  return /* @__PURE__ */ jsx(
    FinanceCalc,
    {
      title: t("widgets.finance.tradeInCard.title"),
      icon: /* @__PURE__ */ jsx(Icon, { name: "service-trade-in", sticker: "trade-in-card-calc-icon", size: 20 }),
      buttonIcon: /* @__PURE__ */ jsx(Icon, { name: "forward", size: 18, sticker: "trade-in-card-forward-icon" }),
      priceLabel: priceLabel || t("widgets.finance.tradeInCard.priceLabel"),
      priceValue: t("format.currency", { value: priceValue }),
      buttonLabel: t("widgets.finance.tradeInCard.buttonLabel"),
      onButtonClick: onClick,
      className: styles.tradeInCard
    }
  );
});
export {
  TradeInCard
};
